<div>
    <h1 class="c11n-text-xl-headline c11n-space-stack-3x" [innerHTML]="accessAgreementHeading"></h1>
<div *ngIf="isLimitedOnly">
    <div class="authorization-body" [innerHTML]="limitedOnlyAccessAgreement"></div>
</div>
<div *ngIf="isInfoOnly">
    <div class="authorization-body" [innerHTML]="infoOnlyAccessAgreement"></div>
</div>
</div>
